export function validateAmountForTransactionType(type: string, value: string): string | null {
  if (!type) {
    return 'Transaction type is required'
  }
  const num = Number(value)
  if (num === 0) return null
  if (type === 'purchase' || type === 'refund') {
    return num < 0 ? null : 'Total amount for purchase or refund must be negative'
  }
  if (type === 'reversal' || type === 'deposit' || type === 'gift') {
    return num > 0 ? null : 'Total amount for reversal, deposit, or gift must be positive'
  }
  if (type === 'other' || type === 'adjustment') {
    return null
  }
  return 'Invalid transaction type'
}

export function amountFieldValidator(
  value: unknown,
  allValues?: { transaction_type?: string }
): string | undefined {
  const type = allValues?.transaction_type ?? ''
  const valueStr = value != null && value !== '' ? String(value) : ''
  if (!type) return undefined
  if (type !== 'other' && valueStr === '') return 'Required'
  const err = validateAmountForTransactionType(type, valueStr)
  return err === null ? undefined : err
}
